module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAOklEQVQoU2NkQAKXGRjqQVxdBoZGmDAjjAGVbIDyG2CKwArQJGF6wIoYcUjCFRFWQNAKohyJpgjFmwDChhStYpT/3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/list.png
// module id = /gKx
// module chunks = 1